import { Route } from 'react-router-dom'
import { ID } from '../utils'
import ResidentCommunicationRecordsScreen from 'screens/Residents/screens/ResidentCommunicationRecordsScreen/ResidentCommunicationRecordsScreen'
import { ResidentProceduresScreen } from 'screens/Residents/screens/ResidentProceduresScreen/ResidentProceduresScreen'
import { ResidentReferralsScreen } from 'screens/Residents/screens/ResidentReferralsScreen'

export const healthRecordsRoutes = () => {
  const routes = []
  routes.push(
    <Route
      key="communication-records"
      path={`${ID}/communication-records`}
      element={<ResidentCommunicationRecordsScreen />}
    />
  )

  routes.push(
    <Route
      key="procedures"
      path={`${ID}/procedures`}
      element={<ResidentProceduresScreen />}
    />
  )

  routes.push(
    <Route
      key="referrals"
      path={`${ID}/referrals`}
      element={<ResidentReferralsScreen />}
    />
  )

  return <>{routes}</>
}
